if (!customElements.get('mx-product-details')) {
  customElements.define('mx-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const select = tab => {
        tabs.forEach(item => {item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1;});
        this.querySelectorAll('[role="tabpanel"]').forEach(panel => {panel.hidden = panel.id !== tab.getAttribute('aria-controls');});
      };
      this.addEventListener('click', event => {const tab = event.target.closest('[role="tab"]'); if (tab) select(tab);}, options);
      this.addEventListener('keydown', event => {
        const index = tabs.indexOf(event.target);
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(tabs[next]); tabs[next].focus();
      }, options);
      this.addEventListener('click', event => {if (event.target.closest('[data-open-fit]')) this.closest('.product-info').querySelector('mx-fit-guide')?.open(event.target.closest('[data-open-fit]'));}, options);
    }
    disconnectedCallback() {this.controller?.abort(); this.controller = null;}
  });
}
if (!customElements.get('mx-fit-guide')) {
  customElements.define('mx-fit-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open-fit]');
        if (trigger) this.open(trigger);
        if (event.target.closest('[data-close-fit]') || event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.trigger?.focus({preventScroll:true}), options);
      this.enhanceOptions();
      const info = this.closest('.product-info');
      if (info) {
        this.optionObserver = new MutationObserver(() => this.enhanceOptions());
        this.optionObserver.observe(info, {childList:true, subtree:true});
      }
    }
    enhanceOptions() {
      const picker = this.closest('.product-info')?.querySelector('variant-picker[context="main_product"]');
      if (!picker) return;
      for (const choice of picker.querySelectorAll('.mx-pdp-color-choice')) {
        const swatch = choice.querySelector('.color-swatch');
        if (!swatch) continue;
        swatch.classList.toggle('is-disabled', choice.dataset.mxColorAvailable === 'false');
        const background = swatch.style.getPropertyValue('--swatch-background').trim();
        if (!background || !CSS.supports('background-image', background)) {
          const fallback = choice.style.getPropertyValue('--mx-pdp-color-fallback').trim();
          swatch.style.setProperty('--swatch-background', fallback);
        }
      }
      const fields = [...picker.querySelectorAll('fieldset')];
      for (const field of fields) {
        if (field.dataset.mxOption) continue;
        const position = field.querySelector('[data-option-position]')?.dataset.optionPosition;
        if (!position) continue;
        const kind = position === this.dataset.stylePosition ? 'style' : position === this.dataset.colorPosition ? 'color' : position === this.dataset.sizePosition ? 'size' : 'other';
        field.dataset.mxOption = kind;
        if ((kind === 'style' && this.dataset.styleCount === '1') || (kind === 'color' && this.dataset.colorCount === '1')) field.classList.add('mx-option-single');
        if (kind === 'style') field.querySelector('legend').textContent = this.dataset.styleLabel;
        if (kind === 'size') {
          const header = field.querySelector('.variant-picker__option-info');
          const trigger = this.querySelector('.mx-pdp-guide-trigger');
          if (header && trigger) {
            const inline = trigger.cloneNode(true);
            inline.classList.add('mx-inline-fit-trigger');
            inline.hidden = false;
            inline.addEventListener('click', () => this.open(inline), {signal:this.controller.signal});
            header.append(inline);
            trigger.hidden = true;
            this.dataset.inline = 'true';
          }
        }
      }
      const rank = {style:0, color:1, size:2, other:3};
      const ordered = [...fields].sort((a,b) => rank[a.dataset.mxOption ?? 'other'] - rank[b.dataset.mxOption ?? 'other']);
      if (fields.some((field,index) => field !== ordered[index])) ordered.forEach(field => picker.append(field));
    }
    open(trigger) {this.trigger = trigger; if (!this.dialog.open) this.dialog.showModal();}
    disconnectedCallback() {this.optionObserver?.disconnect(); if (this.dialog?.open) this.dialog.close(); this.controller?.abort(); this.controller = null;}
  });
}
if (!customElements.get('mx-complete-look')) {
  customElements.define('mx-complete-look', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.controller = new AbortController();
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        fetch(this.dataset.url, {signal:this.controller.signal}).then(response => {if (!response.ok) throw new Error(); return response.text();}).then(html => {
          const result = new DOMParser().parseFromString(html, 'text/html').querySelector('mx-complete-look[data-recommended="true"] .mx-look-grid');
          if (result && this.isConnected) this.querySelector('.mx-look-grid').replaceWith(result);
        }).catch(() => {});
      }, {rootMargin:'200px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {this.observer?.disconnect(); this.observer = null; this.controller?.abort();}
  });
}
